import { fn } from "@/core.js"
import { classList } from "@/utils/classList.js"

import "./toArray.js"

fn.removeClass = classList("remove")
